import { defaultTheme, ThemeProps } from 'themes';

export const customTheme: Partial<ThemeProps> = {
    ...defaultTheme,
};
